import { ErrorInfo, lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from '@components/Layout/components';
import { Loader } from '@components/Loader';
import { FederatedErrorBoundary } from '@components/RemoteMicroFrontends/FederatedErrorBoundary';
import { FooterFallback } from '@components/RemoteMicroFrontends/fallbacks';
import { useAuthStoreContext } from '@context/authStore';
import { CoreBox } from '@youscience/core';
import { sxStyles } from './AdminLayout.styles';
import { SideNav } from './components/SideNav';

const Footer = lazy(() => import('brightpathHeader/Footer'));

export const AdminLayout = () => {
  const { isUpdatingUserPreferences } = useAuthStoreContext();

  return isUpdatingUserPreferences ? (
    <Loader />
  ) : (
    <>
      <CoreBox sx={{ display: 'flex' }}>
        <CoreBox sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <Header />
        </CoreBox>
        <SideNav />
      </CoreBox>
      <CoreBox sx={sxStyles.wrapper}>
        <CoreBox component="main" sx={sxStyles.main}>
          <Outlet />
        </CoreBox>
      </CoreBox>
      <CoreBox sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Suspense fallback={null}>
          <FederatedErrorBoundary
            moduleName="brightpathFooter"
            fallback={<FooterFallback />}
            onError={(error: Error, errorInfo: ErrorInfo) => {
              console.error('Failed to load Footer:', error, errorInfo);
            }}
          >
            <Footer />
          </FederatedErrorBoundary>
        </Suspense>
      </CoreBox>
    </>
  );
};
